export default {
  ad: 0.4795,
  ae: 0.52512,
  af: 0.4795,
  ag: 0.4795,
  ai: 0.4795,
  al: 0,
  am: 0.1734,
  ao: 0.32696,
  aq: 0.4795,
  ar: 0.31916,
  as: 0.4795,
  au: 0.7387,
  aw: 0.4795,
  az: 0.46056,
  ba: 0.78024,
  bb: 0.4795,
  bd: 0.58578,
  bf: 0.4795,
  bh: 0.69726,
  bi: 0.4795,
  bj: 0.6299,
  bl: 0.4795,
  bm: 0.4795,
  bn: 0.70732,
  bo: 0.4025,
  bq: 0.4795,
  br: 0.10852,
  bs: 0.4795,
  bt: 0.4795,
  bv: 0.4795,
  bw: 1.35232,
  by: 0.37254,
  bz: 0.4795,
  ca: 0.13264,
  cd: 0.00062,
  cf: 0.4795,
  cg: 0.51236,
  ci: 0.33756,
  ck: 0.4795,
  cl: 0.42878,
  cm: 0.27784,
  cn: 0.628,
  co: 0.18856,
  cr: 0.00628,
  cu: 0.6982,
  cv: 0.4795,
  cw: 0.61782,
  dj: 0.4795,
  dm: 0.4795,
  dz: 0.49608,
  ec: 0.19374,
  eg: 0.41812,
  eh: 0.4795,
  er: 0.79922,
  et: 0.0003,
  fj: 0.4795,
  fk: 0.4795,
  fm: 0.4795,
  fo: 0.4795,
  ga: 0.55186,
  gb: 0.23282,
  gd: 0.4795,
  ge: 0.09852,
  gg: 0.4795,
  gh: 0.33854,
  gi: 0.67682,
  gl: 0.4795,
  gm: 0.4795,
  gn: 0.4795,
  gq: 0.40554,
  gs: 0.4795,
  gt: 0.35542,
  gu: 0.4795,
  gw: 0.4795,
  gy: 0.79746,
  hk: 0.79746,
  hm: 0.4795,
  hn: 0.32402,
  ht: 0.84732,
  id: 0.7584,
  il: 0.511,
  im: 0.4795,
  in: 0.71956,
  io: 0.4795,
  iq: 0.70266,
  ir: 0.51478,
  je: 0.4795,
  jm: 0.60482,
  jo: 0.44444,
  jp: 0.49844,
  ke: 0.13286,
  kg: 0.05424,
  kh: 0.49956,
  ki: 0.4795,
  km: 0.4795,
  kn: 0.4795,
  kp: 0.22398,
  kr: 0.51438,
  kw: 0.63108,
  ky: 0.4795,
  kz: 0.60102,
  la: 0.41418,
  lb: 0.72796,
  lc: 0.4795,
  lk: 0.59232,
  lr: 0.4795,
  ls: 0.4795,
  ly: 0.63722,
  ma: 0.6876,
  md: 0.49054,
  me: 0.4441,
  mg: 0.59872,
  mh: 0.4795,
  mk: 0.65848,
  ml: 0.4795,
  mm: 0.38132,
  mn: 1.1662,
  mo: 0.4795,
  mp: 0.4795,
  mr: 0.4795,
  ms: 0.4795,
  mu: 0.78052,
  mv: 0.4795,
  mw: 0.4795,
  mx: 0.42928,
  my: 0.6489,
  mz: 0.08626,
  na: 0.04418,
  nc: 0.4795,
  ne: 1.01738,
  nf: 0.4795,
  ng: 0.39756,
  ni: 0.2963,
  np: 0,
  nr: 0.4795,
  nu: 0.4795,
  nz: 0.11468,
  om: 0.43278,
  pa: 0.2698,
  pe: 0.2131,
  pf: 0.4795,
  pg: 0.4795,
  ph: 0.65034,
  pk: 0.38966,
  pl: 0.4795,
  pm: 0.4795,
  pn: 0.4795,
  pr: 0.4795,
  ps: 0.4795,
  pw: 0.4795,
  py: 0,
  qa: 0.48258,
  rs: 0.75574,
  ru: 0.36144,
  rw: 0.34494,
  sa: 0.6256,
  sb: 0.4795,
  sc: 0.4795,
  sd: 0.31686,
  sg: 0.38924,
  sh: 0.4795,
  sj: 0.4795,
  sl: 0.4795,
  sm: 0.4795,
  sn: 0.79138,
  so: 0.4795,
  sr: 0.5248,
  ss: 0.4795,
  st: 0.4795,
  sv: 0.1848,
  sx: 0.4795,
  sy: 0.65568,
  sz: 0.4795,
  tc: 0.4795,
  td: 0.4795,
  tf: 0.4795,
  tg: 0.49034,
  th: 0.47686,
  tj: 0.05374,
  tk: 0.4795,
  tl: 0.4795,
  tm: 0.6988,
  tn: 0.4276,
  to: 0.4795,
  tr: 0.44664,
  tt: 0.55376,
  tv: 0.4795,
  tw: 0.57154,
  tz: 0.3653,
  ua: 0.37318,
  ug: 0.02264,
  us: 0.39994,
  uy: 0.02216,
  uz: 0.5337,
  va: 0.4795,
  vc: 0.4795,
  ve: 0.2659,
  vg: 0.4795,
  vi: 0.4795,
  vn: 0.57016,
  vu: 0.4795,
  wf: 0.4795,
  ws: 0.4795,
  xk: 1.00834,
  ye: 0.69158,
  za: 0.9436,
  zm: 0.13288,
  zr: 0.4795,
  zw: 0.64554
}
